import { render, staticRenderFns } from "./examCard.vue?vue&type=template&id=4727d3d7&scoped=true&"
import script from "./examCard.vue?vue&type=script&lang=js&"
export * from "./examCard.vue?vue&type=script&lang=js&"
import style0 from "./examCard.vue?vue&type=style&index=0&id=4727d3d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4727d3d7",
  null
  
)

export default component.exports